<template>
    <div class="tab-pane active">
        <table class="table table-striped table-sm">
            <thead>
                <tr>
                    <th>#</th>
                    <th>{{ $t('Name') }}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(page, i) in pages" :key="i">
                    <td>{{ i + 1 }}</td>
                    <td>{{ page.name | toUpper }}</td>
                    <td class="p-0">
                        <div class="text-right">
                            <app-button v-if="$store.getters.canEditSettings" native-type="button" @click="$modal.show('update_page', {page})" small>
                                {{ $t('Edit') }}
                            </app-button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <update-modal @setPage="setPage"/>
    </div>
</template>

<script>
import PublicPageService from '@services/publicPage.service';
import UpdateModal from './modals/Update';
import {mapGetters} from 'vuex';
import Vue from 'vue';

export default {
    data() {
        return {
            pages: []
        };
    },
    computed: {
        ...mapGetters(['locale'])
    },
    methods: {
        getPages() {
            PublicPageService.pages().then(res => this.pages = res);
        },
        setPage(page) {
            const index = this.pages.findIndex(p => p.id === page.id);
            if(index !== -1) {
                Vue.set(this.pages, index, page);
            } else {
                this.pages.push(page);
            }
        }
    },
    components: {
        UpdateModal
    },
    created() {
        this.getPages();
    },
    metaInfo() {
        return {
            title: this.$t('Public pages')
        };
    }
};
</script>
